import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fd06ba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  href: "https://www.micurobene.it/contattaci",
  target: "_blank",
  class: "menuItems"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "it" }, "🇮🇹 IT", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "en" }, "🇬🇧 EN", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { reactive } from 'vue';
import { Navbar, NavbarLogo, NavbarCollapse } from 'flowbite-vue';
import { menuItemStore } from '@/store/menu';
import { authStore } from '@/store/authorize';
import router from '@/router';
import { ref, onMounted } from 'vue'
const baseURL = '/webui';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenu',
  emits: ["toggleSubmenu"],
  setup(__props, { emit }) {

const store = authStore();

const items = reactive(menuItemStore().getMenuItems);



onMounted(() => {
    refreshMenu()
})

function refreshMenu() {
    if (items.items && router.currentRoute.value.path) {

        items.items.forEach(obj => {
            if (obj.url === router.currentRoute.value.path)
                emit('toggleSubmenu', obj)
        })
    }
}

function handleLogout() {
    store.logoutUser();

}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Navbar), {
    solid: "",
    class: "menuContainer"
  }, {
    logo: _withCtx(() => [
      _createVNode(_unref(NavbarLogo), {
        link: "/",
        alt: "Esh logo",
        "image-url": "/img/logo_mcb.png"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" MiCuroBene ")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(({ isShowMenu }) => [
      _createVNode(_unref(NavbarCollapse), {
        isShowMenu: isShowMenu,
        class: "navCollapse"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              class: _normalizeClass(_ctx.$route.path === item.url ? 'active' : 'menuItems'),
              onClick: ($event: any) => (_ctx.$emit('toggleSubmenu', item)),
              to: item.active ? item.url : '#'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("nav." + item.label)), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick", "to"]))
          }), 128)),
          _createVNode(_component_router_link, {
            to: "/account",
            class: "menuItems"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Account ")
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.$t('Supporto')), 1),
          _createElementVNode("button", {
            id: "logout-button",
            onClick: _withModifiers(handleLogout, ["prevent"]),
            class: "menuItems"
          }, " Log out ", 8, _hoisted_2),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
            class: "menuItems bg-transparent text-white border-none text-sm ml-2"
          }, _hoisted_5, 512), [
            [_vModelSelect, _ctx.$i18n.locale]
          ])
        ]),
        _: 2
      }, 1032, ["isShowMenu"])
    ]),
    _: 1
  }))
}
}

})